<template>
  <div class="p-10 border rounded-full-large border-polgrey-dark">
    <h2 class="text-2xl font-semibold text-center">Terms and Conditions</h2>
    <div class="text-center text-m">
      <div class="pt-2">
        <p>In order to check your eligibility, we will share your personal information with our partner, Capital One (Europe) plc, who will supply your information to credit reference agencies (CRAs). By working with the CRAs Capital One will do a pre-application check of your credit file using QuickCheck. You'll be able to see the search on your file but it won't show up to other organisations. This means there is no impact to your credit rating.</p>
      </div>
      <div class="pt-5">
        <p>When you 'Check now' Capital One will use your information to find Post Office products or services for you. We will then send confirmation of your eligibility, where eligible, via email, SMS and any applicable reminders of your results.</p>
        <div class="pt-5">
        <p>Before submitting please read the <a target="_blank" class="text-polred" href="https://www.capitalone.co.uk/creditcards/quotation-ts-and-cs.jsf">Terms and Conditions</a> of QuickCheck, as well as the <a id="privacytcpageblock" target="_blank" class="text-polred" href="https://www.postoffice.co.uk/privacy">Post Office</a> and <a target="_blank" class="text-polred" href="https://www.capitalone.co.uk/web/privacy-statement.jsf">Capital One</a> data privacy notices (all links open in new tabs).</p>
      </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TermsAndConditions',
  data() {
    return {}
  },
}

var currentQueryString = window.location.search;
var currentHost = location.protocol+"//"+location.hostname;

document.onload = function () {
  if (currentQueryString) {
    document.getElementById("privacytcpageblock").href = currentHost + "/privacy" + currentQueryString;
  } else {
    document.getElementById("privacytcpageblock").href = currentHost + "/privacy";
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
